import { serverUrl } from "../../config";

export const getImageDimensions = async (images, hash) => {
  const imagePromises = images.map(({ field_image, field_caption, field_image_basename, field_access_token }) => {
    return new Promise((resolve) => {
      const img = new Image();
      
      if (hash) {
        img.src = `${serverUrl}/shared/files/${field_image_basename}?access_token=${field_access_token}`
      } else {
        img.src = `${serverUrl}${field_image}`;
      }

      img.onload = () => {
        resolve({
          src: `${serverUrl}${field_image}`,
          description: field_caption,
          width: img.width ?? 0,
          height: img.height ?? 0,
          basename: field_image_basename,
          access_token: field_access_token
        });
      };
      img.onerror = () => {
        resolve({
          src: field_image,
          description: field_caption,
          width: 0,
          height: 0, 
          basename: field_image_basename,
          access_token: field_access_token
        });
      };
    });
  });

  return Promise.all(imagePromises);
};

